export const getCurrenyTableColumns = (params?: any) => {
  return [
    {
      id: "currencyId",
      label: `Currency ID`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "createdAt",
      label: `Created At`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "updatedAt",
      label: `Updated At`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isoCode",
      label: `ISO Code`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isoNumericCode",
      label: `ISO Numeric Code`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isoName",
      label: `ISO Name`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "minBet",
      label: `Min. Bet`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "maxBet",
      label: `Max. Bet`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "maxPayOut",
      label: `Max. Payout`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "gbpExchangeRate",
      label: `GBP EXCH Rate`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    { id: "actions", label: "Actions" },
  ];
};

export const getPackCategoryTableColumns = (params = {}) => {
  return [
    {
      id: "_id",
      label: `Catetory Id`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "name",
      label: `Name`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isActiveText",
      label: `Is Active`,
      type: "boolean",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "order",
      label: `Order`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    { id: "actions", label: "Actions" },
  ];
};

export const getCardBGTableColumns = (params = {}) => {
  return [
    {
      id: "_id",
      label: `BG Id`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "name",
      label: `Name`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "textColor",
      label: `Text Color`,
      type: "boolean",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    { id: "thumbnail", label: "Preview" },
    { id: "actions", label: "Actions" },
  ];
};

export const getVaultRewardsAndDropRatesTableColumns = (params = {}) => {
  return [
    { id: "level", label: "Level" },
    { id: "rewardType", label: "Reward Type" }, // Player / Coins / Booster
    { id: "playerOvr", label: "Player OVR" }, // Only for player rewards
    { id: "coins", label: "Coins" }, // Only for coin rewards
    { id: "booster", label: "Booster ID" }, // Only for booster rewards
    { id: "probability", label: "Probability (%)" },
    { id: "actions", label: "Actions" },
  ];
};

export const getCardTypeTableColumns = (params = {}) => {
  //   {
  //     "_id": "67b2d4316aba7acb7aaa893c",
  //     "title": "In-Form Players in the Store",
  //     "titleTrans": {
  //         "en": "In-Form Players in the Store",
  //         "es": "Jugadores en Forma en la Tienda",
  //         "de": "Formstarke Spieler im Store",
  //         "fr": "Joueurs en Forme dans la Boutique",
  //         "it": "Giocatori in Forma nel Negozio"
  //     },
  //     "body": "Go to store",
  //     "bodyTrans": {
  //         "en": "Go to store",
  //         "es": "Ir a la tienda",
  //         "de": "Zum Store gehen",
  //         "fr": "Aller à la boutique",
  //         "it": "Vai al negozio"
  //     },
  //     "territory": "ALL",
  //     "isActive": true,
  //     "imageUrl": "https://pbf-dev.s3.amazonaws.com/notificationImages%2FEkNjCHxawZvBpD49l8kIT.png"
  // },

  return [
    {
      id: "_id",
      label: `Notification Id`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "title",
      label: `Title`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "body",
      label: `Body`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "territory",
      label: `Territory`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isActiveText",
      label: `Is Active`,
      type: "boolean",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    { id: "thumbnail", label: "Preview" },
    { id: "actions", label: "Actions" },
  ];
};

export const getQuickBetTableColumns = (params = {}) => {
  return [
    {
      id: "_id",
      label: `Quick Bet ID`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "betsText",
      label: `Bets`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "currency",
      label: `Currency`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "territory",
      label: `Territory`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    { id: "actions", label: "Actions" },
  ];
};

export const getAllUsersTableCols = (params = {}) => {
  return [
    {
      id: "_id",
      label: "User ID",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "rgsPlayerId",
      label: "RGS Player ID",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "team.autoName",
      label: "Team Name",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "balance",
      label: "Balance",
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "right",
    },
    {
      id: "pbfCoin",
      label: "PBF Coin",
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "right",
    },
    {
      id: "currency",
      label: "Currency",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "countryCode",
      label: "Country Code",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "language",
      label: "Language",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "goldStars",
      label: "Gold Stars",
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "seasonPoints",
      label: "Season Points",
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "lastLoginDate",
      label: "Last Login",
      type: "date",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    { id: "actions", label: "Actions" },
  ];
};
